document.addEventListener("DOMContentLoaded", function () {
    // Get stored doctor username from cookie
    const doctorUsername = getCookie("doctor_username");
    console.log("Doctor Username from Cookie:", doctorUsername); // Debugging output

    // Set the value in hidden input fields if doctorUsername exists
    if (doctorUsername) {
        document.querySelectorAll('input[name="attributes[doctor_username]"]').forEach(input => {
            input.value = doctorUsername;
        });
        document.querySelectorAll('input[name="properties[doctor_username]"]').forEach(input => {
            input.value = doctorUsername;
        });
    }

  document.addEventListener('theme:cart:open', function() {
    //console.log('Cart drawer opened!');
    // Set the value in hidden input fields if doctorUsername exists
    if (doctorUsername) {
        document.querySelectorAll('input[name="attributes[doctor_username]"]').forEach(input => {
            input.value = doctorUsername;
        });
    }
  });
});
// Function to get a cookie value by name
function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        let [key, value] = cookie.split('=');
        if (key === name) return value;
    }
    return "";
}
// quick view popup : set doctor username
// MutationObserver to watch for quick view popup
const quickViewObserver = new MutationObserver(() => {
  const doctorInput = document.querySelector('.quick-view-doctor-property');
  const username = getCookie('doctor_username');

  if (doctorInput && username && !doctorInput.value) {
    doctorInput.value = username;
    console.log('quick view doctor_username set from cookie:', username);
  }
});

quickViewObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// cart reload by Sunit
function refreshCartItemsOnly() {
  fetch('/cart?section_id=api-cart-items')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartItems = doc.querySelectorAll('.cart__item');
      const newQtyLabel = doc.querySelector('[data-cart-items-qty]');
      const newFreeShippingMsg = doc.querySelector('[data-cart-message]');
      const newProgressBars = doc.querySelectorAll('[data-cart-message-progress]');
      const newCartTotal = doc.querySelector('[data-cart-total]');
      const newCheckoutTotal = doc.querySelector('[data-cart-total-price]');

      const itemsHolder = document.querySelector('#cartItemsHolder');
      const qtyLabel = document.querySelector('[data-cart-items-qty]');
      const shippingMsg = document.querySelector('[data-cart-message]');
      const progressBars = document.querySelectorAll('[data-cart-message-progress]');
      const cartTotal = document.querySelector('[data-cart-total]');
      const checkoutTotal = document.querySelector('[data-cart-total-price]');

      // Replace cart items
      if (itemsHolder) {
        itemsHolder.innerHTML = '';
        if (newCartItems.length) {
          newCartItems.forEach(item => itemsHolder.appendChild(item));
          itemsHolder.classList.remove('hidden');

          document.querySelector('#cartUpsellHolder')?.classList.remove('hidden');
          document.querySelector('[data-cart-notes-holder]')?.classList.remove('hidden');
          document.querySelector('#cartDrawerEmptyMessage')?.classList.add('hidden');
          document.querySelector('#cartDrawerEmptyMessageBottom')?.classList.add('hidden');
          document.querySelector('#cartDrawerCheckoutForm')?.classList.remove('hidden');
        } else {
          itemsHolder.classList.add('hidden');
          document.querySelector('#cartUpsellHolder')?.classList.add('hidden');
          document.querySelector('[data-cart-notes-holder]')?.classList.add('hidden');
          document.querySelector('#cartDrawerEmptyMessage')?.classList.remove('hidden');
          document.querySelector('#cartDrawerEmptyMessageBottom')?.classList.remove('hidden');
          document.querySelector('#cartDrawerCheckoutForm')?.classList.add('hidden');
        }
      }

      // Update item count label
      if (qtyLabel && newQtyLabel) {
        qtyLabel.textContent = newQtyLabel.textContent;
        qtyLabel.classList.remove('hidden');
      }

      // Update shipping message
      if (shippingMsg && newFreeShippingMsg) {
        shippingMsg.innerHTML = newFreeShippingMsg.innerHTML;
        shippingMsg.classList.remove('is-hidden');
      }

      // Update progress bars
      if (progressBars.length && newProgressBars.length) {
        progressBars.forEach((bar, i) => {
          const newBar = newProgressBars[i];
          if (newBar) {
            bar.value = newBar.value;
            bar.style.setProperty('--progress-width', newBar.style.getPropertyValue('--progress-width'));
          }
        });
      }

      // Update price display
      if (cartTotal && newCartTotal) {
        cartTotal.textContent = newCartTotal.textContent;
      }
      if (checkoutTotal && newCheckoutTotal) {
        checkoutTotal.textContent = newCheckoutTotal.textContent;
      }

      // Trigger Shopify theme events
      document.dispatchEvent(new CustomEvent('theme:cart:update'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));

      console.log('✅ Cart updated (items only, totals, labels preserved).');
    })
    .catch(err => console.error('❌ Cart update failed:', err));
}

/* async function checkSunscreenPromo() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    let targetQuantity = 0;
    const targetTag = 'Sunscreen';

    // Map over all cart items and fetch product data for each
    const productChecks = cart.items.map(async (item) => {
      if (!item.handle) return; // skip if no handle
      const productRes = await fetch(`/products/${item.handle}.js`);
      const productData = await productRes.json();

      const hasTag = productData.tags.includes(targetTag);
      const isNotMerch = !productData.tags.includes('Merch');

      if (hasTag && isNotMerch) {
        targetQuantity += item.quantity;
      }
    });

    await Promise.all(productChecks);

    if (cart.total_price >= 350000 || targetQuantity == 2) {
      document.querySelector('.freeShiping_msg')?.style.setProperty('display', 'flex');
    } else {
      document.querySelector('.freeShiping_msg')?.style.setProperty('display', 'none');
    }

  } catch (error) {
    console.error('Error fetching cart or product data:', error);
  }
}

document.addEventListener('theme:cart:update', function() {
    console.log('Cart drawer updated!');
  checkSunscreenPromo();
  });

document.addEventListener('theme:cart:open', function() {
    console.log('Cart drawer loaded!');
    checkSunscreenPromo();
  });

document.addEventListener('theme:cart:add', function() {
    console.log('Cart drawer updated!');
    checkSunscreenPromo();
  });
*/


